
import React from 'react'
import icon from './svgs/Notes.svg'
import { BaseIcon } from './_base'

export const NotesIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon={icon} {...{fontSize,size,...sx}} />
    )
}
